$(document).ready(function () {
	erInnskradur();
});

function erInnskradur()
{
	var id = setTimeout(function(){
		$.get('/opid/index/erinnskradur', function (data) {
			if(!data) {
				window.location = "/notandi/auth/logout"
			}
			clearTimeout(id);
			erInnskradur();
		})
	},1800000); // 30 minutes
}